import { createWebHistory, createRouter } from "vue-router";
import Body from '../components/body';

import Home from '@/pages/home/home.vue';

import {
    getLandingRoute,
    getStoredAllowedRoutes,
} from '@/utils/landingRoute';

//Authentication Module
import Login from '@/pages/auth/login/login.vue';
import SetPassword from '@/pages/auth/login/set_password.vue';
import ChangePassword from '@/pages/auth/login/change_password.vue';
import RequestOTP from '@/pages/auth/forgot_password/request_otp.vue';
import VerifyOTP from '@/pages/auth/forgot_password/verify_otp.vue';
import ResetPassword from '@/pages/auth/forgot_password/reset_password.vue';

//Dashboards
import Dashboard from '../pages/dashboard/dashboard.vue';
import TargetAchievementDetail from '../pages/dashboard/management/cards/target_vs_achievement_details.vue';
import VehicleWiseSalesDetail from '../pages/dashboard/management/cards/lorry_wise_sale_details.vue';
import SkuWiseSalesDetail from '../pages/dashboard/management/cards/sku_wise_sale_details.vue';
import ProductiveVsNonProductive from '../pages/dashboard/management/cards/productive_vs_non_productive_logs_details.vue';

//User profile and settings
import Profile from '@/pages/master_data/users/profile/userProfile.vue';
import Settings from '@/pages/master_data/users/settings/settings.vue';

//Master Data Module
import usersList from "@/pages/master_data/users/users/usersList.vue";
import newUser from "@/pages/master_data/users/users/newUser.vue";
import editUser from "@/pages/master_data/users/users/editUser.vue";
import userRoles from "@/pages/master_data/users/userRoles/userRoles.vue";
import newUserRole from "@/pages/master_data/users/userRoles/newUserRole.vue";
import editUserRole from "@/pages/master_data/users/userRoles/editUserRole.vue";
import itemList from "@/pages/master_data/items/items/itemList.vue";
import createItem from "@/pages/master_data/items/items/createItem.vue";
import editItem from "@/pages/master_data/items/items/editItem.vue";
import ItemPriceHistory from "../pages/master_data/items/item_price/item_price_history.vue";
import ItemPriceChange from "../pages/master_data/items/item_price/item_price_change.vue";
import ItemPriceApprove from "../pages/master_data/items/item_price_approve/item_price_approve.vue";
import DistributorTarget from "@/pages/master_data/targets/distributor_target/distributor_target.vue";
import VehicleSeTarget from "@/pages/master_data/targets/vehicle_se_target/vehicle_se_target.vue";
import TargetHistory from "@/pages/master_data/targets/target_history/target_history.vue";
import DistributorStaff from "@/pages/master_data/distributor_staff/distributor_staff.vue";
import NewStaff from "@/pages/master_data/distributor_staff/new_staff.vue";
import EditStaff from "@/pages/master_data/distributor_staff/edit_staff.vue";
import dealerList from "@/pages/master_data/dealers/dealerList.vue";
import addDealer from "@/pages/master_data/dealers/addDealer.vue";
import editDealer from "@/pages/master_data/dealers/editDealer.vue";
import verifyDealer from "@/pages/master_data/dealers/verifyDealer.vue";
import DistributorBanks from "@/pages/master_data/distributor_banks/distributor_banks.vue";
import NewBanks from "@/pages/master_data/distributor_banks/new_banks.vue";
import EditBanks from "@/pages/master_data/distributor_banks/edit_banks.vue";
import Promotions from "@/pages/master_data/promotions/promotions/promotion.vue";
import CreatePromotion from "@/pages/master_data/promotions/promotions/create_promotion.vue";
import EditPromotion from "@/pages/master_data/promotions/promotions/edit_promotion.vue";
import ManagePromotions from "@/pages/master_data/promotions/promotions/manage_promotions.vue";
import ViewPromotion from "@/pages/master_data/promotions/promotions/view_promotion.vue";
import PromotionApproval from "@/pages/master_data/promotions/promotions_approve/promotion_approval.vue";
import ReviewPromotion from "@/pages/master_data/promotions/promotions_approve/review_promotion.vue";
import Routes from "@/pages/master_data/routes/routes.vue";
import CreateRoute from "@/pages/master_data/routes/createRoute.vue";
import ViewRoute from "@/pages/master_data/routes/viewRoute.vue";
import EditRoute from "@/pages/master_data/routes/editRoute.vue";
import DistributorVehicles from "@/pages/master_data/distributor_vehicles/distributor_vehicles.vue";
import NewVehicle from "@/pages/master_data/distributor_vehicles/new_vehicle.vue";
import EditVehicle from "@/pages/master_data/distributor_vehicles/edit_vehicle.vue";
import WorkingDayCalendar from "@/pages/master_data/working_day_calendar/working_day_calendar.vue";
import DealerGroups from "@/pages/master_data/dealer_groups/dealerGroups.vue";
import CreateDealerGroup from "@/pages/master_data/dealer_groups/createDealerGroup.vue";
import EditDealerGroup from "@/pages/master_data/dealer_groups/editDealerGroup.vue";
import ViewDealerGroup from "@/pages/master_data/dealer_groups/viewDealerGroup.vue";
import ModuleRouteConfigurations from "@/pages/master_data/module_route_configurations/modules.vue";
import CreateModule from "@/pages/master_data/module_route_configurations/create_module.vue";
import EditModule from "@/pages/master_data/module_route_configurations/edit_module.vue";
import ViewModule from "@/pages/master_data/module_route_configurations/view_module.vue";

//Invoice Module
import Invoice from "@/pages/invoice/viewInvoice/invoice.vue"
import invoicePayments from "@/pages/invoice/invoicePayments/invoicePayments.vue";
import newInvoice from "@/pages/invoice/newInvoice/newInvoice.vue";

//Order Module
import OrderManagement from "@/pages/orders/orderManagement.vue";

//Complaint Module
import ComplaintManagement from '@/pages/complaint/complaintManagement.vue';

//Stock Module
import OrderHistory from "@/pages/stock/order_request/orderRequestHistory.vue";
import OrderRequest from "@/pages/stock/order_request/orderRequest.vue";
import EditOrderRequest from '@/pages/stock/order_request/editOrderRequest.vue';
import OrderRequestSchedule from "@/pages/stock/order_request_schedule/poshedule.vue";
import OrderRequestScheduleEdit from '@/pages/stock/order_request_schedule/posheduleEdit.vue';
import Grn from '@/pages/stock/grn/grnhome.vue';
import GrnRequest from '@/pages/stock/grn/grn.vue';
import EditGrnRequest from '@/pages/stock/grn/grnedit.vue';
import StockAllocation from "@/pages/stock/stock_allocation/stockAllocation.vue";
import NewStockAllocation from "@/pages/stock/stock_allocation/newStockAllocation.vue";
import EditeStockAllocation from '@/pages/stock/stock_allocation/editeStockAlloction.vue'
import Dispatch from "@/pages/stock/dispatch/distpatch.vue";
import NewDispatch from "@/pages/stock/dispatch/newDistpatch.vue";
import EditDispatch from "@/pages/stock/dispatch/distpachedit.vue";
import GetPass from "@/pages/stock/gate_pass/getPass.vue";
import GetPassIn from "@/pages/stock/gate_pass_in/getPassIn.vue";
import StockAdjustment from "@/pages/stock/stock_adjustment/stockAdjustment.vue";
import StockAdjustmentApproval from "@/pages/stock/stock_adjustment_approval/stockAdjustmentApproval.vue";
import StockAdjustmentHistory from "@/pages/stock/stock_adjustment_history/stockAdjustmentHistory.vue";
import InitialStock from "@/pages/stock/initial_stock/initialStock.vue";
import DeliveryScheduleList from "@/pages/stock/delivery_shedule_old/deliveryShedule_old.vue";
import DispatchLocations from "@/pages/stock/delivery_shedule_old/createSchedule_old.vue";
import DeliverySchedule from "@/pages/stock/delivery_schedule/delivery_schedule.vue";
import DeliveryScheduleHistory from "@/pages/stock/delivery_schedule_history/delivery_schedule_history.vue";
import DeliveryScheduleEdit from "@/pages/stock/delivery_schedule_edit/delivery_schedule_edit.vue";

//Reports Module
import SalesReport from "@/pages/report/sales/salesReport.vue";
import OrderRequestScheduleReport from "@/pages/report/po_schedule/posheduleReport.vue";
import VehicleWiseStockReport from "@/pages/report/vehicle_wise_stock/vehiclewisestockreport.vue";
import DistributorStockReport from '@/pages/report/distributor_stocks/distributorstocks.vue';
import InvoiceSummeryReport from '@/pages/report/invoice_summery/invoiceSummery.vue';
import DealerVisitReport from "@/pages/report/dealer_visit/dealervisit.vue";
import DirectLossSaleReport from '@/pages/report/direct_loss_sale/directLossSale.vue';
import ASMFSMwiseSaleReport from '@/pages/report/asmfsmwisesales/asmfsmwisesalesreport.vue'; // added 2025/ 12/ 03
import DealerStatement from '@/pages/report/dealerstatementreport/dealerstatementreport.vue'; // added 2025/ 12/ 15
import DistributorWiseDealerStock from '@/pages/report/DistributorWiseDealerStock/distributorwisedealerstock.vue';
import DayEndReport from '@/pages/report/dayreport/dayreport.vue';
import DealersalesReport from '@/pages/report/dealersales/dealersalesreport.vue';
import DistributorsalesReport from '@/pages/report/distributorsales/distributorsalesreport.vue';
import DealerStatementReport from '@/pages/report/DealerStatement/statement.vue';
import DailySalesMonitoringReport from '@/pages/report/dailysalesmonitoringreport/dailysalesmonitoring.vue';
import DealerVatReport from '@/pages/report/dealerVATreport/delaervatreport.vue';
import StockReturnReport from '@/pages/report/stockReturn/stock_return_report.vue';
import cashBalancingReport from '@/pages/report/cashBalancingReport/cash_balancing_report.vue';
import creditNoteReport from '@/pages/report/creditNoteReport/credit_note_report.vue';
import trustProcessReport from '@/pages/report/trustProcessReport/trust_process_report.vue';
import ageingAnalysisReport from '@/pages/report/ageingAnalysisReport/ageingAnalysisReport.vue';

//Real-Time Tracker
import RealTimeTracker from '@/pages/maps/live_tracker/real_time_tracker.vue';

//Show System Errors
import AccessDenied from '@/pages/errors/access_denied.vue';
import PageNotFound from '@/pages/errors/not_found.vue';
import DocumentTemplatesManagement from "@/pages/system_config/document_templates/documentTemplatesManagement.vue";
import AddDocumentTemplate from "@/pages/system_config/document_templates/addDocumentTemplate.vue";
import SystemParametersManagement from "@/pages/system_config/system_parameters/systemParametersManagement.vue";
import AddSystemParameter from "@/pages/system_config/system_parameters/addSystemParameter.vue";
import TrustDealerList from "@/pages/master_data/trust_management/trustDealerList.vue";
import IssueTrust from "@/pages/master_data/trust_management/issueTrust.vue";
import TrustHistory from "@/pages/master_data/trust_management/trustHistory.vue";
import ViewTrustDetails from "@/pages/master_data/trust_management/viewTrustDetails.vue";
import ApprovalConsole from "@/pages/administration/approval_console/approvalConsole.vue";
import ReviewDealer from "@/pages/master_data/dealers/reviewDealer.vue";
import ReviewTrust from "@/pages/master_data/trust_management/reviewTrust.vue";

// Define routes
const routes = [
    //Redirect the route path `/` based on user authentication status
    {
        path: '/',
        redirect: () => {
            const token = localStorage.getItem('token_set');

            if (!token) {
                return '/login';
            }

            const allowedRoutes = getStoredAllowedRoutes();

            return getLandingRoute(allowedRoutes);
        }
    },

    //AUTHENTICATION MODULE ROUTE PATH
    {
        path: '/login',
        children: [
            {
                path: '/login',
                name: 'Login',
                component: Login,
                meta: {
                    title: 'SFA | Login',
                    requiresAuth: false,
                },
            },
        ],
    },
    {
        path: '/set-password',
        children: [
            {
                path: '/set-password',
                name: 'SetPassword',
                component: SetPassword,
                meta: {
                    title: 'SFA | Set Password',
                    requiresAuth: false,
                },
            },
        ],
    },
    {
        path: '/change-password',
        children: [
            {
                path: '/change-password',
                name: 'ChangePassword',
                component: ChangePassword,
                meta: {
                    title: 'SFA | Change Password',
                    requiresAuth: false,
                },
            },
        ],
    },
    {
        path: '/request-otp',
        children: [
            {
                path: '/request-otp',
                name: 'RequestOTP',
                component: RequestOTP,
                meta: {
                    title: 'SFA | Forgot Password',
                    requiresAuth: false,
                },
            },
        ],
    },
    {
        path: '/verify-otp',
        children: [
            {
                path: '/verify-otp',
                name: 'VerifyOTP',
                component: VerifyOTP,
                meta: {
                    title: 'SFA | OTP Verification',
                    requiresAuth: false,
                },
            },
        ],
    },
    {
        path: '/reset-password',
        children: [
            {
                path: '/reset-password',
                name: 'ResetPassword',
                component: ResetPassword,
                meta: {
                    title: 'SFA | Reset Password',
                    requiresAuth: false,
                },
            },
        ],
    },

    //DASHBOARDS
    {
        path: '/dashboard',
        component: Body,
        children: [
            {
                path: '/dashboard',
                name: 'Dashboard',
                component: Dashboard,
                meta: {
                    title: 'SFA | Dashboard',
                    requiresAuth: true,
                },
            },
        ],
    },


    // HOME - For authenticated users without Dashboard permission
    {
        path: '/home',
        component: Body,
        children: [
            {
                path: '/home',
                name: 'Home',
                component: Home,
                meta: {
                    title: 'SFA | Home',
                    requiresAuth: true,
                },
            },
        ],
    },

    {
        path: '/target-achievement/detail',
        component: Body,
        children: [
            {
                path: '/target-achievement/detail',
                name: 'TargetAchievementDetail',
                component: TargetAchievementDetail,
                meta: {
                    title: 'SFA | TargetAchievementDetail',
                    requiresAuth: true,
                },
            },
        ],
    },

    {
        path: '/vehicle-wise-sales/detail',
        component: Body,
        children: [
            {
                path: '/vehicle-wise-sales/detail',
                name: 'VehicleWiseSalesDetail',
                component: VehicleWiseSalesDetail,
                meta: {
                    title: 'SFA | VehicleWiseSalesDetail',
                    requiresAuth: true,
                },
            },
        ],
    },

    {
        path: '/sku-wise-sales/detail',
        component: Body,
        children: [
            {
                path: '/sku-wise-sales/detail',
                name: 'SkuWiseSalesDetail',
                component: SkuWiseSalesDetail,
                meta: {
                    title: 'SFA | SkuWiseSalesDetail',
                    requiresAuth: true,
                },
            },
        ],
    },

    {
        path: '/productive-vs-nonproductive/detail',
        component: Body,
        children: [
            {
                path: '/productive-vs-nonproductive/detail',
                name: 'ProductiveVsNonProductiveDetail',
                component: ProductiveVsNonProductive,
                meta: {
                    title: 'SFA | CallSummary',
                    requiresAuth: true,
                },
            },
        ],
    },

    //USER PROFILE AND SETTINGS
    {
        path: '/profile/:name',
        component: Body,
        children: [
            {
                path: '/profile/:name',
                name: 'Profile',
                component: Profile,
                meta: {
                    title: 'SFA | Profile',
                    requiresAuth: true,
                },
            },
        ],
    },
    {
        path: '/settings',
        component: Body,
        children: [
            {
                path: '/settings',
                name: 'Settings',
                component: Settings,
                meta: {
                    title: 'SFA | Settings',
                    requiresAuth: true,
                },
            },
        ],
    },

    //MASTER DATA MODULE ROUTE PATH
    {
        path: '/users',
        component: Body,
        children: [
            {
                path: '/users',
                name: 'UsersList',
                component: usersList,
                meta: {
                    title: 'SFA | Users',
                    requiresAuth: true,
                }
            },
        ],
    },
    {
        path: '/create-user',
        component: Body,
        children: [
            {
                path: '/create-user',
                name: 'NewUser',
                component: newUser,
                meta: {
                    title: 'SFA | Create New User',
                    requiresAuth: true,
                },
            },
        ],
    },
    {
        path: '/edit-user/:id',
        component: Body,
        children: [
            {
                path: '/edit-user/:id',
                name: 'EditUser',
                component: editUser,
                meta: {
                    title: 'SFA | Edit User',
                    requiresAuth: true,
                },
            },
        ],
    },
    {
        path: '/user-roles',
        component: Body,
        children: [
            {
                path: '/user-roles',
                name: 'User-Roles',
                component: userRoles,
                meta: {
                    title: 'SFA | User Roles',
                    requiresAuth: true,
                },
            },
        ],
    },
    {
        path: '/new-user-role',
        component: Body,
        children: [
            {
                path: '/new-user-role',
                name: 'New-User-Role',
                component: newUserRole,
                meta: {
                    title: 'SFA | Create New User Role',
                    requiresAuth: true,
                },
            },
        ],
    },
    {
        path: '/user-role-edit/:id',
        component: Body,
        children: [
            {
                path: '/user-role-edit/:id',
                name: 'EditUserRole',
                component: editUserRole,
                meta: {
                    title: 'SFA | Edit User Role',
                    requiresAuth: true,
                },
            },
        ],
    },
    {
        path: '/items',
        component: Body,
        children: [
            {
                path: '/items',
                name: 'itemList',
                component: itemList,
                meta: {
                    title: 'SFA | Items',
                    requiresAuth: true,
                },
            },
        ],
    },
    {
        path: '/edit-item/:id',
        component: Body,
        children: [
            {
                path: '/edit-item/:id',
                name: 'editItem',
                component: editItem,
                meta: {
                    title: 'SFA | Edit Item',
                    requiresAuth: true,
                },
            },
        ],
    },
    {
        path: '/create-item',
        component: Body,
        children: [
            {
                path: '/create-item',
                name: 'createItem',
                component: createItem,
                meta: {
                    title: 'SFA | Create New Item',
                    requiresAuth: true,
                },
            },
        ],
    },
    {
        path: '/item-price-history',
        component: Body,
        children: [
            {
                path: '/item-price-history',
                name: 'ItemPriceHistory',
                component: ItemPriceHistory,
                meta: {
                    title: 'SFA | Item Price History',
                    requiresAuth: true,
                },
            },
        ],
    },
    {
        path: '/item-price-change',
        component: Body,
        children: [
            {
                path: '/item-price-change',
                name: 'ItemPriceChange',
                component: ItemPriceChange,
                meta: {
                    title: 'SFA | Item Price Change',
                    requiresAuth: true,
                },
            },
        ],
    },
    {
        path: '/item-price-approve',
        component: Body,
        children: [
            {
                path: '/item-price-approve',
                name: 'ItemPriceApprove',
                component: ItemPriceApprove,
                meta: {
                    title: 'SFA | Item Price Approve',
                    requiresAuth: true,
                },
            },
        ],
    },

    {
        path: '/distributor-target',
        component: Body,
        children: [
            {
                path: '/distributor-target',
                name: 'DistributorTarget',
                component: DistributorTarget,
                meta: {
                    title: 'SFA | Distributor Target',
                },
            },
        ],
    },
    {
        path: '/vehicle-se-target',
        component: Body,
        children: [
            {
                path: '/vehicle-se-target',
                name: 'VehicleSeTarget',
                component: VehicleSeTarget,
                meta: {
                    title: 'SFA | Vehicle & SE Target',
                },
            },
        ],
    },
    {
        path: '/distributor-target-history',
        component: Body,
        children: [
            {
                path: '/distributor-target-history',
                name: 'TargetHistory',
                component: TargetHistory,
                meta: {
                    title: 'SFA | Distributor Target History',
                },
            },
        ],
    },
    {
        path: '/distributor-staff',
        component: Body,
        children: [
            {
                path: '/distributor-staff',
                name: 'DistributorStaff',
                component: DistributorStaff,
                meta: {
                    title: 'SFA | Distributor Staff',
                },
            },
        ],
    },
    {
        path: '/new-staff',
        component: Body,
        children: [
            {
                path: '/new-staff',
                name: 'NewStaff',
                component: NewStaff,
                meta: {
                    title: 'SFA | Create Distributor Staff',
                },
            },
        ],
    },
    {
        path: '/edit-staff/:id',
        component: Body,
        children: [
            {
                path: '/edit-staff/:id',
                name: 'EditStaff',
                component: EditStaff,
                meta: {
                    title: 'SFA | Edit Distributor Staff',
                },
            },
        ],
    },
    {
        path: '/dealers',
        component: Body,
        children: [
            {
                path: '/dealers',
                name: 'dealer-list',
                component: dealerList,
                meta: {
                    title: 'SFA | Dealers',
                    requiresAuth: true,
                }
            }
        ]
    },
    {
        path: '/add-dealer',
        component: Body,
        children: [
            {
                path: '',
                name: 'addDealer',
                component: addDealer,
                meta: {
                    title: 'SFA | Add Dealer',
                    requiresAuth: true
                }
            }
        ]
    },
    {
        path: '/edit-dealer/:id',
        component: Body,
        children: [
            {
                path: '/edit-dealer/:id',
                name: 'editDealer',
                component: editDealer,
                meta: {
                    title: 'SFA | Edit Dealer',
                    requiresAuth: true
                }
            }
        ]
    },
    {
        path: '/verify-dealer/:id',
        component: Body,
        children: [
            {
                path: '/verify-dealer/:id',
                name: 'verifyDealer',
                component: verifyDealer,
                meta: {
                    title: 'SFA | Verify Dealer',
                    requiresAuth: true
                }
            }
        ]
    },
    {
        path: '/review-dealer/:id',
        component: Body,
        children: [
            {
                path: '/review-dealer/:id',
                name: 'reviewDealer',
                component: ReviewDealer,
                meta: {
                    title: 'SFA | Review Dealer',
                    requiresAuth: true
                }
            }
        ]
    },
    {
        path: '/distributor-banks',
        component: Body,
        children: [
            {
                path: '/distributor-banks',
                name: 'DistributorBanks',
                component: DistributorBanks,
                meta: {
                    title: 'SFA | Distributor Banks',
                },
            },
        ],
    },
    {
        path: '/distributor-vehicles',
        component: Body,
        children: [
            {
                path: '/distributor-vehicles',
                name: 'DistributorVehicles',
                component: DistributorVehicles,
                meta: {
                    title: 'SFA | Distributor Vehicles',
                },
            },
        ],
    },
    {
        path: '/new-vehicle',
        component: Body,
        children: [
            {
                path: '/new-vehicle',
                name: 'NewVehicle',
                component: NewVehicle,
                meta: {
                    title: 'SFA | Create Distributor Vehicle',
                },
            },
        ],
    },
    {
        path: '/edit-vehicle/:id',
        component: Body,
        children: [
            {
                path: '',
                name: 'EditVehicle',
                component: EditVehicle,
                meta: {
                    title: 'SFA | Edit Distributor Vehicle',
                },
            },
        ],
    },
    {
        path: '/new-banks',
        component: Body,
        children: [
            {
                path: '/new-banks',
                name: 'NewBanks',
                component: NewBanks,
                meta: {
                    title: 'SFA | Create Distributor Bank',
                },
            },
        ],
    },
    {
        path: '/edit-banks/:id',
        component: Body,
        children: [
            {
                path: '',
                name: 'EditBanks',
                component: EditBanks,
                meta: {
                    title: 'SFA | Edit Distributor Bank',
                },
            },
        ],
    },
    {
        path: '/promotions',
        component: Body,
        children: [
            {
                path: '',
                name: 'promotions',
                component: Promotions,
                meta: {
                    title: 'SFA | Promotions',
                    requiresAuth: true
                }
            }
        ]
    },
    {
        path: '/create-promotion',
        component: Body,
        children: [
            {
                path: '',
                name: 'create-promotion',
                component: CreatePromotion,
                meta: {
                    title: 'SFA | Create Promotion',
                    requiresAuth: true
                }
            }
        ]
    },
    {
        path: '/edit-promotion',
        component: Body,
        children: [
            {
                path: '',
                name: 'edit-promotion',
                component: EditPromotion,
                meta: {
                    title: 'SFA | Edit Promotion',
                    requiresAuth: true
                }
            }
        ]
    },
    {
        path: '/manage-promotions',
        component: Body,
        children: [
            {
                path: '',
                name: 'manage-promotions',
                component: ManagePromotions,
                meta: {
                    title: 'SFA | Manage Promotions',
                    requiresAuth: true
                }
            }
        ]
    },
    {
        path: '/view-promotion',
        component: Body,
        children: [
            {
                path: '',
                name: 'view-promotion',
                component: ViewPromotion,
                meta: {
                    title: 'SFA | View Promotion',
                    requiresAuth: true
                }
            }
        ]
    },
    {
        path: '/promotion_approval',
        component: Body,
        children: [
            {
                path: '',
                name: 'promotion_approval',
                component: PromotionApproval,
                meta: {
                    title: 'SFA | Promotion Approval',
                    requiresAuth: true
                }
            }
        ]
    },
    {
        path: '/review-promotion',
        component: Body,
        children: [
            {
                path: '',
                name: 'review-promotion',
                component: ReviewPromotion,
                meta: {
                    title: 'SFA | Review Promotion',
                    requiresAuth: true
                }
            }
        ]
    },
    {
        path: '/routes',
        component: Body,
        children: [
            {
                path: '',
                name: 'Routes',
                component: Routes,
                meta: {
                    title: 'SFA | Routes',
                    requiresAuth: true
                }
            }
        ]
    },
    {
        path: '/create-route',
        component: Body,
        children: [
            {
                path: '',
                name: 'create-route',
                component: CreateRoute,
                meta: {
                    title: 'SFA | Create Route',
                    requiresAuth: true
                }
            }
        ]
    },
    {
        path: '/view-route',
        component: Body,
        children: [
            {
                path: '',
                name: 'view-route',
                component: ViewRoute,
                meta: {
                    title: 'SFA | View Route',
                    requiresAuth: true
                }
            }
        ]
    },
    {
        path: '/edit-route',
        component: Body,
        children: [
            {
                path: '',
                name: 'edit-route',
                component: EditRoute,
                meta: {
                    title: 'SFA | Edit Route',
                    requiresAuth: true
                }
            }
        ]
    },
    {
        path: '/working-day-calendar',
        component: Body,
        children: [
            {
                path: '',
                name: 'working-day-calendar',
                component: WorkingDayCalendar,
                meta: {
                    title: 'SFA | Working Day Calendar',
                    requiresAuth: true
                }
            }
        ]
    },
    {
        path: '/module-route-configurations',
        component: Body,
        children: [
            {
                path: '',
                name: 'moduleRouteConfigurations',
                component: ModuleRouteConfigurations,
                meta: {
                    title: 'SFA | Module & Route Configurations',
                    requiresAuth: true
                }
            }
        ]
    },
    {
        path: '/create-module',
        component: Body,
        children: [
            {
                path: '',
                name: 'createModule',
                component: CreateModule,
                meta: {
                    title: 'SFA | Create Module',
                    requiresAuth: true
                }
            }
        ]
    },
    {
        path: '/edit-module/:id',
        component: Body,
        children: [
            {
                path: '',
                name: 'editModule',
                component: EditModule,
                meta: {
                    title: 'SFA | Edit Module',
                    requiresAuth: true
                }
            }
        ]
    },
    {
        path: '/view-module/:id',
        component: Body,
        children: [
            {
                path: '',
                name: 'viewModule',
                component: ViewModule,
                meta: {
                    title: 'SFA | View Module',
                    requiresAuth: true
                }
            }
        ]
    },
    {
        path: '/dealer-groups',
        component: Body,
        children: [
            {
                path: '',
                name: 'dealer-groups',
                component: DealerGroups,
                meta: {
                    title: 'SFA | Dealer Groups',
                    requiresAuth: true
                }
            }
        ]
    },
    {
        path: '/create-dealer-group',
        component: Body,
        children: [
            {
                path: '',
                name: 'create-dealer-group',
                component: CreateDealerGroup,
                meta: {
                    title: 'SFA | Create Dealer Group',
                    requiresAuth: true
                }
            }
        ]
    },
    {
        path: '/edit-dealer-group',
        component: Body,
        children: [
            {
                path: '',
                name: 'edit-dealer-group',
                component: EditDealerGroup,
                meta: {
                    title: 'SFA | Edit Dealer Group',
                    requiresAuth: true
                }
            }
        ]
    },
    {
        path: '/view-dealer-group',
        component: Body,
        children: [
            {
                path: '',
                name: 'view-dealer-group',
                component: ViewDealerGroup,
                meta: {
                    title: 'SFA | View Dealer Group',
                    requiresAuth: true
                }
            }
        ]
    },

    //SYSTEM CONFIG MODULE ROUTE PATH
    {
        path: '/document-templates-management',
        component: Body,
        children: [
            {
                path: '/document-templates-management',
                name: 'DocumentTemplates',
                component: DocumentTemplatesManagement,
                meta: {
                    title: 'SFA | Document Templates',
                    requiresAuth: true,
                }
            },
        ],
    },
    {
        path: '/add-document-template/:id?',
        component: Body,
        children: [
            {
                path: '/add-document-template/:id?',
                name: 'AddDocumentTemplates',
                component: AddDocumentTemplate,
                props: true,
                meta: {
                    title: 'SFA | Add Document Template',
                    requiresAuth: true,
                }
            },
        ],
    },
    {
        path: '/system-parameters',
        component: Body,
        children: [
            {
                path: '/system-parameters',
                name: 'SystemParameters',
                component: SystemParametersManagement,
                meta: {
                    title: 'SFA | System Parameters',
                    requiresAuth: true,
                }
            },
        ],
    },
    {
        path: '/add-system-parameter/:id?',
        component: Body,
        children: [
            {
                path: '/add-system-parameter/:id?',
                name: 'AddSystemParameter',
                component: AddSystemParameter,
                props: true,
                meta: {
                    title: 'SFA | System Parameter',
                    requiresAuth: true,
                }
            },
        ],
    },
    {
        path: '/trust-management',
        component: Body,
        children: [
            {
                path: '',
                name: 'trust-management',
                component: TrustDealerList,
                meta: {
                    title: 'SFA | Trust Dealer List',
                    requiresAuth: true
                }
            }
        ]
    },
    {
        path: '/issue-trust/:id',
        component: Body,
        children: [
            {
                path: '',
                name: 'issue-trust',
                component: IssueTrust,
                meta: {
                    title: 'SFA | Issue New Trust',
                    requiresAuth: true
                }
            }
        ]
    },
    {
        path: '/trust-history/:id',
        component: Body,
        children: [
            {
                path: '',
                name: 'trust-history',
                component: TrustHistory,
                meta: {
                    title: 'SFA | Trust History',
                    requiresAuth: true
                }
            }
        ]
    },
    {
        path: '/review-trust/:id',
        component: Body,
        children: [
            {
                path: '/review-trust/:id',
                name: 'reviewTrust',
                component: ReviewTrust,
                meta: {
                    title: 'SFA | Review Trust',
                    requiresAuth: true
                }
            }
        ]
    },
    {
        path: '/view-trust-details/:id',
        component: Body,
        children: [
            {
                path: '',
                name: 'view-trust-details',
                component: ViewTrustDetails,
                meta: {
                    title: 'SFA | View Trust Details',
                    requiresAuth: true
                }
            }
        ]
    },

    //ADMINISTRATION MODULE ROUTE PATH
    {
        path: '/approval-console',
        component: Body,
        children: [
            {
                path: '/approval-console',
                name: 'ApprovalConsole',
                component: ApprovalConsole,
                meta: {
                    title: 'SFA | Approval Console',
                    requiresAuth: true,
                }
            },
        ],
    },

    //INVOICE MODULE ROUTE PATH
    {
        path: '/invoice',
        component: Body,
        children: [
            {
                path: '/invoice',
                name: 'Invoice',
                component: Invoice,
                meta: {
                    title: 'SFA | Invoices',
                    requiresAuth: true,
                },
            },
        ],
    },
    {
        path: '/invoice-payment',
        component: Body,
        children: [
            {
                path: '',
                name: 'invoicePayment',
                component: invoicePayments,
                meta: {
                    title: 'SFA | Invoice Payments',
                    requiresAuth: true,
                }
            }
        ]
    },
    {
        path: '/new-invoice',
        component: Body,
        children: [
            {
                path: '',
                name: 'newInvoice',
                component: newInvoice,
                meta: {
                    title: 'SFA | New Invoice',
                    requiresAuth: true,
                }
            }
        ]
    },

    //ORDER MODULE ROUTE PATH
    {
        path: '/orders',
        component: Body,
        children: [
            {
                path: '/orders',
                name: 'OrderManagement',
                component: OrderManagement,
                meta: {
                    title: 'SFA | Order Management',
                    requiresAuth: true,
                },
            },
        ],
    },

    //COMPLAINT MODULE ROUTE PATH
    {
        path: '/complaints',
        component: Body,
        children: [
            {
                path: '/complaints',
                name: 'ComplaintManagement',
                component: ComplaintManagement,
                meta: {
                    title: 'SFA | Complaint Management',
                    requiresAuth: true,
                },
            },
        ],
    },

    //STOCK MODULE ROUTE PATH
    {
        path: '/order-request-history',
        component: Body,
        children: [
            {
                path: '/order-request-history',
                name: 'OrderHistory',
                component: OrderHistory,
                meta: {
                    title: 'SFA | Order Requests',
                    requiresAuth: true,
                },
            },
        ],
    },
    {
        path: '/order-create',
        component: Body,
        children: [
            {
                path: '/order-create',
                name: 'OrderRequest',
                component: OrderRequest,
                meta: {
                    title: 'SFA | Create Order Request',
                    requiresAuth: true,
                },
            },
        ],
    },
    {
        path: '/edit-order-request/:id',
        component: Body,
        children: [
            {
                path: '',
                name: 'EditOrderRequest',
                component: EditOrderRequest,
                meta: {
                    title: 'SFA | Edit Order Request',
                    requiresAuth: true,
                },
            },
        ],
    },
    {
        path: '/order-request-schedule',
        component: Body,
        children: [
            {
                path: '/order-request-schedule',
                name: 'OrderRequestSchedule',
                component: OrderRequestSchedule,
                meta: {
                    title: 'SFA | Order Request Schedule',
                    requiresAuth: true,
                },
            },
        ],
    },
    {
        path: '/order-request-schedule-edit/:id',
        component: Body,
        children: [
            {
                path: '/order-request-schedule-edit/:id',
                name: 'OrderRequestScheduleEdit',
                component: OrderRequestScheduleEdit,
                meta: {
                    title: 'SFA | Edit Order Request Schedule',
                    requiresAuth: true,
                }
            },
        ],
    },
    {
        path: '/grn',
        component: Body,
        children: [
            {
                path: '/grn',
                name: 'GRN',
                component: Grn,
                meta: {
                    title: 'SFA | Goods Received Notes',
                    requiresAuth: true,
                },
            },
        ],
    },
    {
        path: '/grn-request',
        component: Body,
        children: [
            {
                path: '/grn-request',
                name: 'GrnRequest',
                component: GrnRequest,
                meta: {
                    title: 'SFA | Create Good Received Note',
                    requiresAuth: true,
                },
            },
        ],
    },
    {
        path: '/edit-grn/:id',
        component: Body,
        children: [
            {
                path: '',
                name: 'EditGrnRequest',
                component: EditGrnRequest,
                meta: {
                    title: 'SFA | Edit GRN Request',
                    requiresAuth: true,
                },
            },
        ],
    },
    {
        path: '/stock-allocation',
        component: Body,
        children: [
            {
                path: '/stock-allocation',
                name: 'StockAllocation',
                component: StockAllocation,
                meta: {
                    title: 'SFA | Stock Allocation',
                    requiresAuth: true,
                },
            },
        ]
    },
    {
        path: '/new-stock-allocation',
        component: Body,
        children: [
            {
                path: '/new-stock-allocation',  // Add this new route for New Stock Allocation
                name: 'NewStockAllocation',
                component: NewStockAllocation,
                meta: {
                    title: 'SFA | New Stock Allocation',
                    requiresAuth: true,
                },
            },
        ]
    },
    {
        path: '/edit-stock-allocation/:id',
        component: Body,
        children: [
            {
                path: '/edit-stock-allocation/:id',
                name: 'EditeStockAllocation',
                component: EditeStockAllocation,
                meta: {
                    title: 'SFA | Edit Stock Allocation',
                    requiresAuth: true,
                },
            },
        ]
    },
    {
        path: '/dispatch',
        component: Body,
        children: [
            {
                path: '/dispatch',
                name: 'Dispatch',
                component: Dispatch,
                meta: {
                    title: 'SFA | Dispatch',
                    requiresAuth: true,
                },
            },
        ]
    },
    {
        path: '/new-dispatch',
        component: Body,
        children: [
            {
                path: '/new-dispatch',
                name: 'NewDispatch',
                component: NewDispatch,
                meta: {
                    title: 'SFA | New Dispatch',
                    requiresAuth: true,
                },
            },
        ]
    },
    {
        path: '/dispatch-edit/:id',
        component: Body,
        children: [
            {
                path: '/dispatch-edit/:id',
                name: 'EditDispatch',
                component: EditDispatch,
                meta: {
                    title: 'SFA | Edit Dispatch',
                    requiresAuth: true,
                },
            },
        ]
    },
    {
        path: '/gate-pass',
        component: Body,
        children: [
            {
                path: '/gate-pass',
                name: 'GetPass',
                component: GetPass,
                meta: {
                    title: 'SFA | Gate Pass Out',
                    requiresAuth: true,
                },
            },
        ]
    },
    {
        path: '/gate-pass-in',
        component: Body,
        children: [
            {
                path: '/gate-pass-in',
                name: 'GetPassIn',
                component: GetPassIn,
                meta: {
                    title: 'SFA | Get Pass In',
                    requiresAuth: true,
                },
            },
        ]
    },
    {
        path: '/stock-adjustment',
        component: Body,
        children: [
            {
                path: '/stock-adjustment',
                name: 'Stock Adjustment',
                component: StockAdjustment,
                meta: {
                    title: 'SFA | Stock Adjustment',
                    requiresAuth: true,
                },
            },
        ]
    },
    {
        path: '/stock-adjustment-approval',
        component: Body,
        children: [
            {
                path: '/stock-adjustment-approval',
                name: 'Stock Adjustment Approval',
                component: StockAdjustmentApproval,
                meta: {
                    title: 'SFA | Stock Adjustment Approval',
                    requiresAuth: true,
                },
            },
        ]
    },
    {
        path: "/stock-adjustment-history",
        component: Body,
        children: [
            {
                path: "/stock-adjustment-history",
                name: "Stock Adjustment History",
                component: StockAdjustmentHistory,
                meta: {
                    title: "SFA | Stock Adjustment History",
                    requiresAuth: true,
                },
            },
        ],
    },
    {
        path: '/initial-stock',
        component: Body,
        children: [
            {
                path: '/initial-stock',
                name: 'Initial Stock',
                component: InitialStock,
                meta: {
                    title: 'SFA | Initial Stock',
                    requiresAuth: true,
                },
            },
        ]
    },
    {
        path: '/delivery-shedule',
        component: Body,
        children: [
            {
                path: '/delivery-shedule',
                name: 'Delivery Shedule',
                component: DeliveryScheduleList,
                meta: {
                    title: 'SFA | Delivery Shedule',
                    requiresAuth: true,
                },
            },
        ]
    },
    {
        path: '/delivery-schedule',
        component: Body,
        children: [
            {
                path: '/delivery-schedule',
                name: 'Delivery Schedule',
                component: DeliverySchedule,
                meta: {
                    title: 'SFA | Delivery Schedule',
                    requiresAuth: true,
                },
            },
        ]
    },
    {
        path: '/delivery-schedule-history',
        component: Body,
        children: [
            {
                path: '/delivery-schedule-history',
                name: 'Delivery Schedule History',
                component: DeliveryScheduleHistory,
                meta: {
                    title: 'SFA | Delivery Schedule History',
                    requiresAuth: true,
                },
            },
        ]
    },
    {
        path: '/delivery-schedule-edit/:id',
        component: Body,
        children: [
            {
                path: '',
                name: 'DeliveryScheduleEdit',
                component: DeliveryScheduleEdit,
                meta: {
                    title: 'SFA | Delivery Schedule Edit',
                    requiresAuth: true,
                },
            },
        ]
    },


    {
        path: '/dispatch-locations',
        component: Body,
        children: [
            {
                path: '/dispatch-locations',
                name: 'DispatchLocations',
                component: DispatchLocations,
                meta: {
                    title: 'SFA | Dispatch Locations',
                    requiresAuth: true,
                },
            },
        ]
    },

    //REPORT MODULE ROUTE PATH
    {
        path: '/daily-sales-report',
        component: Body,
        children: [
            {
                path: '/daily-sales-report',
                name: 'Sales Daily Report',
                component: SalesReport,
                meta: {
                    title: 'SFA | Sales Daily Update',
                    requiresAuth: true,
                },
            },
        ],
    },
    {
        path: '/order-request-schedule-report',
        component: Body,
        children: [
            {
                path: '/order-request-schedule-report',
                name: 'OrderRequestScheduleReport',
                component: OrderRequestScheduleReport,
                meta: {
                    title: 'SFA | Order Request Schedule Report',
                    requiresAuth: true,
                },
            },
        ],
    },
    {
        path: '/vehicle-stock-report',
        component: Body,
        children: [
            {
                path: '/vehicle-stock-report',
                name: 'VehicleWiseStockReport',
                component: VehicleWiseStockReport,
                meta: {
                    title: 'SFA | Vehicle Stock Report',
                    requiresAuth: true,
                },
            },
        ],
    },
    {
        path: '/distributor-stock-report',
        component: Body,
        children: [
            {
                path: '/distributor-stock-report',
                name: 'DistributorStockReport',
                component: DistributorStockReport,
                meta: {
                    title: 'SFA | Distributor Stock Report',
                    requiresAuth: true,
                },
            },
        ],
    },
    {
        path: '/dayend-report',
        component: Body,
        children: [
            {
                path: '/dayend-report',
                name: 'DayEndReport',
                component: DayEndReport,
                meta: {
                    title: 'SFA | Day End Report',
                    requiresAuth: true,
                },
            },
        ],
    },
    {
        path: '/distributor-wise-dealer-sales-report',
        component: Body,
        children: [
            {
                path: '/distributor-wise-dealer-sales-report',
                name: 'DealersalesReport',
                component: DealersalesReport,
                meta: {
                    title: 'SFA | Distributor Wise Dealer Sales Report',
                    requiresAuth: true,
                },
            },
        ],
    },
    {
        path: '/dealerStatement',
        children: [
            {
                path: '/dealerStatement',
                name: 'DealerStatementReport',
                component: DealerStatementReport,
                meta: {
                    title: 'SFA | Day End Report',
                    requiresAuth: true,
                },
            },
        ],
    },
    {
        path: '/distributorsales',
        component: Body,
        children: [
            {
                path: '/distributorsales',
                name: 'DistributorsalesReport',
                component: DistributorsalesReport,
                meta: {
                    title: 'SFA | Day End Report',
                    requiresAuth: true,
                },
            },
        ],
    },
    {
        path: '/asmfsmwisesales',
        component: Body,
        children: [
            {
                path: '/asmfsmwisesales',
                name: 'AsmfsmSaleReport',
                component: ASMFSMwiseSaleReport,
                meta: {
                    title: 'SFA | ASM/FSM wise Sales Report',
                    requiresAuth: true,
                },
            },
        ],
    },
    {
        path: '/dealerstatementreport',
        component: Body,
        children: [
            {
                path: '/dealerstatementreport',
                name: 'DealerStatementReport',
                component: DealerStatement,
                meta: {
                    title: 'SFA | Dealer Statement Report',
                    requiresAuth: true,
                },
            },
        ],
    },
    {
        path: '/distributor-wise-dealer-stock-report',
        component: Body,
        children: [
            {
                path: '/distributor-wise-dealer-stock-report',
                name: 'DistributorWiseDealerStockReport',
                component: DistributorWiseDealerStock,
                meta: {
                    title: 'SFA | Distributor Wise Dealer Stock Report',
                    requiresAuth: true,
                },
            },
        ],
    },
    {
        path: '/daily-sales-monitoring-report',
        component: Body,
        children: [
            {
                path: '/daily-sales-monitoring-report',
                name: 'DailySalesMonitoringReport',
                component: DailySalesMonitoringReport,
                meta: {
                    title: 'SFA | Daily Sales Monitoring Report',
                    requiresAuth: true,
                },
            },
        ],
    },
    {
        path: '/dealer-vat-report',
        component: Body,
        children: [
            {
                path: '/dealer-vat-report',
                name: 'DealerVatReport',
                component: DealerVatReport,
                meta: {
                    title: 'SFA | Dealer VAT Report',
                    requiresAuth: true,
                },
            },
        ],
    },
    {
        path: '/invoice-summary-report',
        component: Body,
        children: [
            {
                path: '/invoice-summary-report',
                name: 'InvoiceSummeryReport',
                component: InvoiceSummeryReport,
                meta: {
                    title: 'SFA | Invoice Summary Report',
                    requiresAuth: true,
                },
            },
        ],
    },
    {
        path: '/dealer-visit-report',
        component: Body,
        children: [
            {
                path: '',
                name: 'DealerVisitReport',
                component: DealerVisitReport,
                meta: {
                    title: 'SFA | Dealer Visit Report',
                    requiresAuth: true,
                },
            },
        ],
    },
    {
        path: '/direct-loss-sale-report',
        component: Body,
        children: [
            {
                path: '/direct-loss-sale-report',
                name: 'DirectLossSaleReport',
                component: DirectLossSaleReport,
                meta: {
                    title: 'SFA | Direct Loss Sale',
                    requiresAuth: true,
                },
            },
        ],
    },
    {
        path: '/stock-return-report',
        component: Body,
        children: [
            {
                path: '/stock-return-report',
                name: '',
                component: StockReturnReport,
                meta: {
                    title: 'SFA | Stock Return Report',
                    requiresAuth: true,
                },
            },
        ],
    },
    {
        path: '/cash-balancing-report',
        component: Body,
        children: [
            {
                path: '/cash-balancing-report',
                name: '',
                component: cashBalancingReport,
                meta: {
                    title: 'SFA | Cash Balancing Report',
                    requiresAuth: true,
                },
            },
        ],
    },
    {
        path: '/credit-note-report',
        component: Body,
        children: [
            {
                path: '/credit-note-report',
                name: '',
                component: creditNoteReport,
                meta: {
                    title: 'SFA | Credit Note Report',
                    requiresAuth: true,
                },
            },
        ],
    },
    {
        path: '/trust_process_report',
        component: Body,
        children: [
            {
                path: '/trust_process_report',
                name: '',
                component: trustProcessReport,
                meta: {
                    title: 'SFA | Trust Process Report',
                    requiresAuth: true,
                },
            },
        ],
    },
    {
        path: '/ageing-analysis-report',
        component: Body,
        children: [
            {
                path: '/ageing-analysis-report',
                name: '',
                component: ageingAnalysisReport,
                meta: {
                    title: 'SFA | Ageing Analysis Report',
                    requiresAuth: true,
                },
            },
        ],
    },



    //REAL-TIME GPS TRACKER
    {
        path: '/real-time-tracker',
        children: [
            {
                path: '/real-time-tracker',
                name: 'RealTimeTracker',
                component: RealTimeTracker,
                meta: {
                    title: 'SFA | Real Time Tracker',
                    requiresAuth: false,
                },
            },
        ],
    },

    // Common Routes for show system errors. When you adding specific routes then it add before this routes.
    {
        path: '/page-not-found',
        children: [
            {
                path: '/page-not-found',
                name: 'PageNotFound',
                component: PageNotFound,
                meta: {
                    title: 'SFA | Page Not Found',
                    requiresAuth: false,
                },
            },
        ],
    },
    {
        path: '/access-denied',
        children: [
            {
                path: '/access-denied',
                name: 'AccessDenied',
                component: AccessDenied,
                meta: {
                    title: 'SFA | Access Denied',
                    requiresAuth: false,
                },
            },
        ],
    },

    //Redirect to log in if no matching route is found
    {
        path: '/:catchAll(.*)',
        redirect: '/page-not-found',
    },
];

//Create the router instance
const router = createRouter({
    history: createWebHistory(),
    routes,
});

// These are public paths that do not require authentication
const publicPaths = ['/login', '/request-otp', '/page-not-found', '/access-denied'];

// These are paths for password setup and modification flows
const specialPasswordPaths = ['/set-password', '/change-password'];

// These are paths for OTP verification and password reset flows
const otpFlowPaths = ['/verify-otp', '/reset-password'];

// These are paths allowed for all logged-in users
const universalAuthPaths = ['/home'];

router.beforeEach((to, from, next) => {
    const isPublic = publicPaths.includes(to.path);
    const isSpecialPasswordPath = specialPasswordPaths.includes(to.path);
    const isLoggedIn = !!localStorage.getItem('token_set');
    const allowedRoutes = getStoredAllowedRoutes();
    const hasUserId = !!localStorage.getItem('user_id');
    const hasMobile = !!localStorage.getItem('mobile');
    const hasOtp = !!localStorage.getItem('otp');

    // If route is public — allow
    if (isPublic) {
        next();
        return;
    }

    // Step restriction: /set-password, /change-password
    if (specialPasswordPaths.includes(to.path)) {
        if (from.path === '/login' && hasUserId) {
            next();
        } else {
            next('/access-denied');
        }
        return;
    }

    // Step restriction: /verify-otp
    if (to.path === '/verify-otp') {
        if (from.path === '/request-otp' && hasMobile) {
            next();
        } else {
            next('/request-otp');
        }
        return;
    }

    // Step restriction: /reset-password
    if (to.path === '/reset-password') {
        if (from.path === '/verify-otp' && hasMobile && hasOtp) {
            next();
        } else {
            next('/request-otp');
        }
        return;
    }

    // If not logged in — redirect to login
    if (!isLoggedIn) {
        next('/login');
        return;
    }

    // Allow if it's a universal path
    if (universalAuthPaths.includes(to.path)) {
        next();
        return;
    }

    const internalAllowedRoutes = [
        {
            path: '/delivery-schedule-edit',
            parentPermissions: [
                '/delivery-schedule',
                '/delivery-schedule-history',
            ],
        },
    ];

    const hasInternalAccess = internalAllowedRoutes.some((item) => {
        const isInternalPath = to.path.startsWith(item.path);

        const hasParentPermission = item.parentPermissions.some((permission) => {
            return allowedRoutes.includes(permission);
        });

        return isInternalPath && hasParentPermission;
    });

    if (hasInternalAccess) {
        next();
        return;
    }

    // Normalize path by removing trailing slash if present
    const normalizedToPath = to.path.endsWith('/') ? to.path.slice(0, -1) : to.path;

    // Check if the user has access to this route (handling trailing slashes and prefix dynamic matching)
    const hasAccess = allowedRoutes.some(route => {
        const normalizedRoute = route.endsWith('/') ? route.slice(0, -1) : route;

        // Exact match (ignoring trailing slashes)
        if (normalizedToPath === normalizedRoute) {
            return true;
        }

        // Dynamic prefix match (e.g. /edit-vehicle/:id matches /edit-vehicle/)
        if (route.endsWith('/') && to.path.startsWith(route)) {
            return true;
        }

        return false;
    });

    if (hasAccess) {
        next();
        return;
    }


    // Otherwise, redirect to access-denied
    next('/access-denied');
});

// Update page title after navigation
router.afterEach((to) => {
    // Use next tick to handle the title update
    setTimeout(() => {
        if (to.meta.title) {
            document.title = to.meta.title;
        } else {
            document.title = 'LAUGFS | Sales Force Automation'; // Default title
        }
    }, 0);
});
// Export the router
export default router;